/**
 * User-facing strings for the links between the brand and admin dashboards:
 * a line under each login form and a button in each signed-in top bar.
 * Same i18n-ready shape as shopifyCopy.
 */
export const appSwitchCopy = {
  /** Shown on the brand login page, pointing at the admin app. */
  brandLogin: { prefix: 'Discovr team member?', label: 'Open the Admin dashboard' },
  /** Shown on the admin login page, pointing at the brand app. */
  adminLogin: { prefix: 'Not on the team?', label: 'Open the brand dashboard' },
  /** Top-bar button labels. */
  openBrandApp: 'Open brand app',
  openAdminApp: 'Open Admin',
} as const;
